import { createReducer, on } from '@ngrx/store';
import { languageInitialState } from '@store/states/language.state';
import { languageActions } from '@store/actions/language.actions';

export const languageReducer = createReducer(
  languageInitialState,
  on(languageActions.changeLanguage, (state, { lang }) => ({
    ...state,
    lang,
  })),
  on(languageActions.setVisibilityLang, (state, { visibilityLang }) => ({
    ...state,
    visibilityLang: visibilityLang,
  }))
);
